import {getAuthenticationRedirectUrl} from '@/api/authentication/authenticationRedirectUrl';
import type {AuthorizationSettings} from '@/api/models/authentication/authorizationSettings';
import {authorizationSettingsKey} from '@/api/queries/keys/subdomainKeys';
import AuthenticationRepository from '@/api/repositories/AuthenticationRepository';
import {appConfig} from '@/config/appConfig';
import {useQuery} from '@tanstack/vue-query';
import type {Ref} from 'vue';

export function useAuthorizationSettingsQuery(subdomain: Ref<string | null>) {
    return useQuery({
        queryKey: authorizationSettingsKey(subdomain),
        queryFn: async () => {
            if (!subdomain.value) {
                return null;
            }
            const settings: AuthorizationSettings = await AuthenticationRepository().authSettings(
                subdomain.value
            );

            if (appConfig.isHybridApp && settings.openIdConnectConfiguration) {
                if ('redirectUri' in settings.openIdConnectConfiguration) {
                    settings.openIdConnectConfiguration.redirectUri =
                        getAuthenticationRedirectUrl('login');
                }
            }

            return settings as AuthorizationSettings;
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}
